<template>
    <div class="group_13 flex-col justify-end">
        <div class="group_14 flex-row">
            <span class="text_33">{{ $portalText('footer', 't001') }}</span>
            <span class="text_34">{{ $portalText('footer', 't002') }}</span>
            <span class="text_35">{{ $portalText('footer', 't003') }}</span>
            <div class="section_12 flex-col"></div>
        </div>
        <div class="group_15 flex-row">
            <img class="image_20" referrerpolicy="no-referrer" :src="IconLogo" />
            <div class="image-wrapper_3 flex-col">
                <img class="label_7" referrerpolicy="no-referrer" :src="commpanyIcon" />
            </div>
            <div class="group_16 flex-col justify-between">
                <div class="block_5 flex-row justify-between">
                    <img class="label_8" referrerpolicy="no-referrer" :src="addressIcon" />
                    <span class="text_36">{{ $portalText('footer', 't004') }}</span>
                </div>
                <div class="image-text_11 flex-row justify-between">
                    <img class="label_9" referrerpolicy="no-referrer" :src="emailIcon" />
                    <span class="text-group_11">{{ $portalText('footer', 't005') }}</span>
                </div>
            </div>
            <img class="thumbnail_4" referrerpolicy="no-referrer" :src="phoneIcon" />
            <span class="text_37">{{ $portalText('footer', 't006') }}</span>
        </div>
        <div class="group_17 flex-col"></div>
        <div class="text-wrapper_10 flex-row">
            <span class="text_38">{{ $portalText('footer', 't007') }}</span>
            <span class="text_39" @click="convertLoad($portalText('footer', 'l001'))">{{ $portalText('footer', 't008') }}</span>
            <span class="text_40" @click="convertLoad($portalText('footer', 'l002'))">{{ $portalText('footer', 't009') }}</span>
            <span class="text_41" @click="convertLoad($portalText('footer', 'l003'))">{{ $portalText('footer', 't010') }}</span>
        </div>
        <div class="text-wrapper_11 flex-row">
            <span class="text_42">{{ $portalText('footer', 't011') }}<span class="copyright_active" @click="convertLoad($portalText('footer', 'l004'))">{{ $portalText('footer', 't012') }}</span></span>
        </div>
    </div>
</template>
<script>
import { portalData } from '@/portal/runtime';

import IconLogo from '@/assets/images/portal/logo.png';
import commpanyIcon from '@/assets/images/footerNav/commpany_icon.png';
import addressIcon from '@/assets/images/footerNav/address_icon.png';
import emailIcon from '@/assets/images/footerNav/email_icon.png';
import phoneIcon from '@/assets/images/footerNav/phone_icon.png'
export default {
  portalScope: 'footer',
    data() {
        return portalData('footer', {
            IconLogo,
            commpanyIcon,
            addressIcon,
            emailIcon,
            phoneIcon
        })
    },
    methods: {
        convertLoad(url) {
            window.open(url);
        }
    }
}
</script>
<style lang="less" scoped>
@import url('./index.less');
</style>
